var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-center justify-center fraction fraction-simple"},[_c('div',{staticClass:"fraction-top",style:(this.needBottomLine ? ' border-bottom: 2px solid #263238' : '')},[_vm._t("default")],2),_c('div',{staticClass:"fraction-bottom"},[_vm._t("bottom")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }